// extracted by mini-css-extract-plugin
export default {"stpes-infom-wrap":"StepsRecordList_stpes-infom-wrap__7gCLc","stpes-infom-box":"StepsRecordList_stpes-infom-box__i1EVa","inner-box":"StepsRecordList_inner-box__iDwtD"};